import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';

class Content extends React.PureComponent {
  getBlockChildren = (data) =>
    data.map((item, i) => {
      const children = item.children;
      const noAttributeList = ['gray'];
      const attribute = Object.entries(item).reduce((obj ,[ key, value ]) => {
        return !noAttributeList.includes(key) ? {...obj, [key]: value} : obj
      }, {});
      return (
        <Col key={i.toString()} {...attribute} >
          <a href={children.link}>
          <div className={item.gray?'gray-item':''}>
            <div {...children.icon}>
              <img src={children.icon.children} width="100%" alt="img" />
            </div>
            <h2 {...children.title}>{children.title.children}</h2>
            <div {...children.content}>{children.content.children}</div>
          </div>
          </a>
        </Col>
      );
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const listChildren = this.getBlockChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </div>
          <OverPack {...dataSource.OverPack}>
            <QueueAnim
              type="bottom"
              key="block"
              leaveReverse
              {...dataSource.block}
              component={Row}
            >
              {listChildren}
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default Content;
